import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CompteOperateurService } from './shared/services/operateur/compte.operateur.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {

    constructor(private translate: TranslateService) {
        translate.setDefaultLang('fr');
    }

    ngOnInit() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('arabe');

    }
}
